import _ from 'underscore';
import constants from '../constants/index';
import normalize from '../lib/normalize';

export const references = [
	{reference: 'meeting_id', association: 'meeting', source: 'meetings'},
	{reference: 'teacher_ids', association: 'teachers', source: 'teachers'},
	{reference: 'cohort_ids', association: 'cohorts', source: 'cohorts'},
];

const defaultState = normalize({selected: [], inspected: []}, null, references);

export default function scheduledMeetingsReducer(state = defaultState, action) {
	let newState = state;
	let ids;

	switch(action.type) {
		case constants.REQUEST_SCHEDULED_MEETINGS_SUCCESS:
			newState = normalize(state, action.payload.scheduledMeetings);
			break;

		case constants.SELECT_VIEWER_CELL:
			newState = Object.assign({}, newState);
			if(action.payload.selected) {
				newState.inspected = [action.payload.scheduledMeetingId.toString()];
			}
			else {
				newState.inspected = _.without(
					newState.inspected,
					action.payload.scheduledMeetingId.toString()
				);
			}
			break;

		case constants.SELECT_TEACHER:
		case constants.SELECT_TEACHERS:
		case constants.SELECT_PARTICIPANTS_GROUP:
			if(!action.payload.selected) {
				newState = Object.assign({}, newState, {inspected: []});
			}
			break;

		case constants.UNSELECT_TEACHERS:
		case constants.UNSELECT_COHORTS:
			newState = Object.assign({}, newState, {inspected: []});
			break;

		case constants.CHANGE_SCHEDULED_MEETING_NAMES:
			let meeting_id = action.payload.meeting_id;
			ids = action.payload.ids;
			newState = Object.assign({}, newState);
			newState.entities = Object.assign({}, newState.entities);
			
			ids.reduce((entities, id) => {
				entities[id] = Object.assign(
					{}, 
					newState.entities[id],
					{ name:meeting_id, meeting_id: meeting_id }
				);
				return entities;
			}, newState.entities)
			
			break;
			
		default:
	}
	return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/scheduled_meetings_reducer.js
 **/